import { Label } from "reactstrap";
import "./SearchBox.css";
import React from "react";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Tooltip } from "@mui/material";

interface IKDatePickerProps {
  placeHolder?: string;
  label?: string;
  value?: Date | undefined;
  minDate?: Date;
  maxDate?: Date;
  onChange: (date: Date) => void;
  disabled?: boolean;
  labelIcon?: any;
  labelIconTooltipContent?: string;
}

const KDatePicker: React.FunctionComponent<IKDatePickerProps> = (props) => {
  return (
    <div className="mb-2">
      {props.label && (
        <Label className={`${props?.labelIcon ? 'mb-0' : 'mb-1'} text-start search-label text-muted`}>
          {props.label}
          <Tooltip 
            title={props?.labelIconTooltipContent} 
            placement="bottom-start"
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: 'black',
                  fontSize: '12px'
                }
              }
            }}
          >
            {props?.labelIcon && props?.labelIcon}
          </Tooltip>
        </Label>
      )}
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DemoContainer components={["DatePicker"]}>
          <DatePicker
            disabled={props.disabled}
            minDate={props.minDate ? moment(props.minDate) : undefined}
            maxDate={props.maxDate ? moment(props.maxDate) : undefined}
            className="date-picker"
            value={props.value ? moment(props.value, "DD-MM-YYYY") : null}
            format="DD-MM-YYYY"
            onChange={(newValue) => {
              props.onChange(newValue ? newValue.toDate() : moment().toDate());
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                  borderColor: "transparent",
                  borderRadius: "8px !important",
                },
                "&:hover fieldset": {
                  borderRadius: "8px !important",
                  border: "1px solid #B6C4E3 !important",
                },
                "&.Mui-focused fieldset": {
                  borderRadius: "8px !important",
                  border: "1px solid #5C79AA !important",
                  boxShadow: "0 0 0 1px #5C79AA",
                },
              },
              "& .MuiInputBase-input": {
                fontSize: "11px !important",
                color: "#5C79AA !important",
                padding: "8px 12px !important",
              },
              "& .MuiInputBase-root": {
                borderRadius: "8px !important",
                border: "1px solid #B6C4E3 !important",
                backgroundColor: "white !important",
                transition: "all 0.2s ease",
              },
              "& .MuiIconButton-root": {
                color: "#5C79AA !important",
                padding: "4px !important",
              },
              "& .MuiIconButton-root:hover": {
                backgroundColor: "#f0f4f8 !important",
              },
            }}
            slots={{
              openPickerIcon: () => (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ color: "#5C79AA" }}
                >
                  <path
                    d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.6949 13.7H15.7039M15.6949 16.7H15.7039M11.9955 13.7H12.0045M11.9955 16.7H12.0045M8.29431 13.7H8.30329M8.29431 16.7H8.30329"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ),
            }}
          />
        </DemoContainer>
      </LocalizationProvider>
    </div>
  );
};

export default KDatePicker;
